import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { FileImportDto } from '../../pages/members/collection/services/collection.service';
import { GcsService } from '../../services/gcs.service';

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @Output() urlsChange = new EventEmitter<{ url: string; order: number; altText: string }[]>();
    @Input() initialImages: { url: string; order: number; altText?: string }[] = [];
    @Input() maxImages = 10;

    draggedIndex: number | null = null;
    showCropper = false;
    selectedFileBase64 = '';

    images: { url?: string; altText?: string; loading: boolean; order: number }[] = [];
    constructor(private readonly _gcsService: GcsService) {

    }
    ngOnInit() {
        this.loadInitialImages();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['initialImages'] && !changes['initialImages'].firstChange) {
            this.loadInitialImages();
        }
    }

    private loadInitialImages() {
        if (this.initialImages?.length) {
            this.images = this.initialImages
                .sort((a, b) => a.order - b.order)
                .map((img, i) => ({
                    url: img.url,
                    altText: img.altText ?? '',
                    loading: false,
                    order: i
                }));
            this.emitResult();
        } else {
            this.images = [];
        }
    }

    openFileDialog() {
        this.fileInput.nativeElement.click();
    }

    onFileSelected(event: any) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            this.selectedFileBase64 = reader.result as string;
            this.showCropper = true;
        };
        reader.readAsDataURL(file);
    }

    handleCropped(file: File) {
        this.showCropper = false;
        this.uploadImage(file);
    }

    cancelCrop() {
        this.showCropper = false;
        this.selectedFileBase64 = '';
    }

    uploadImage(file: File) {
        const index = this.images.length;
        this.images.push({ loading: true, order: index });

        const reader = new FileReader();
        reader.onload = () => {
            const base64Content = (reader.result as string).split(',')[1];

            const body: FileImportDto = FileImportDto.fromJS({
                fileName: file.name,
                fileContent: base64Content,
                mimeType: file.type,

            })

            this._gcsService.upload(body).subscribe({
                next: (res: { fileUrl: string }) => {
                    this.images[index].url = res.fileUrl;
                    this.images[index].loading = false;
                    this.emitResult();
                },
                error: (e) => {
                    this.images.splice(index, 1);
                    console.log(e.message)
                }
            })
        };

        reader.readAsDataURL(file);
    }

    removeImage(i: number) {
        this.images.splice(i, 1);
        this.updateOrder();
        this.emitResult();
    }

    onDragStart(index: number) {
        this.draggedIndex = index;
    }

    onDrop(index: number) {
        if (this.draggedIndex === null) return;
        const dragged = this.images[this.draggedIndex];
        this.images.splice(this.draggedIndex, 1);
        this.images.splice(index, 0, dragged);
        this.updateOrder();
        this.emitResult();
        this.draggedIndex = null;
    }

    updateOrder() {
        this.images.forEach((img, i) => (img.order = i));
    }

    emitResult() {
        this.urlsChange.emit(
            this.images
                .filter(img => img.url)
                .map((img) => ({
                    url: img.url!,
                    order: img.order,
                    altText: img.altText ?? ''
                }))
        );
    }
}
